import Api from './index';

const getClickAways = (bookId, params: any) => {
  return Api.get(`/books/${bookId}/click-aways`, { params });
};

export { getClickAways };
